import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Group, Button } from '@mantine/core';
import IconRotate from '../../icons/IconRotate';
import IlluEmptyImage from '../../../assets/illu-image-empty.svg';

import styles from './styles.scoped.css';

export default function ImageRotator({ image, title, customeComponent }) {
  const [deg, setDeg] = useState(0);
  const [countMove, setCountMove] = useState(0);
  const imageRef = useRef(null);

  const handleRotateLeft = () => {
    setDeg((prevState) => (prevState -= 90));
    setCountMove((prevState) => prevState - 1);
  };

  const handleRotateRight = () => {
    setDeg((prevState) => (prevState += 90));
    setCountMove((prevState) => prevState + 1);
  };

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.style.transform = `rotate(${deg}deg)`;
    }
  }, [deg, imageRef]);

  return (
    <Card className={styles.root} p="xl" radius="md" withBorder>
      <div className={styles.header}>
        <p>{title}</p>
        {customeComponent}
      </div>
      <img
        alt={title}
        ref={imageRef}
        src={image || IlluEmptyImage}
        style={{ margin: Math.abs(countMove) % 2 === 1 ? '5rem' : 0 }}
      />
      {image && (
        <Group>
          <Button
            leftIcon={<IconRotate fill="#5E811E" />}
            onClick={handleRotateLeft}
            radius="sm"
            variant="outline"
          >
          Putar ke kiri
          </Button>
          <Button
            leftIcon={<IconRotate fill="#5E811E" right />}
            onClick={handleRotateRight}
            radius="sm"
            variant="outline"
          >
          Putar ke kanan
          </Button>
        </Group>
      )}
    </Card>
  );
}

ImageRotator.propTypes = {
  customeComponent: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
